import React, { useState } from 'react';
import { getUserInitials } from '../../utils/userUtils';

const ProfilePicture = ({ profilePicture, user, size = 'w-10 h-10', className = '' }) => {
  const [imageError, setImageError] = useState(false);
  const initials = getUserInitials(user);
  const displaySize = size || 'w-10 h-10';

  if (profilePicture && !imageError) {
    return (
      <>
        <img
          src={profilePicture}
          alt={user?.fullName || 'User'}
          className={`${displaySize} rounded-lg object-cover ${className}`}
          onError={() => setImageError(true)}
        />
      </>
    );
  }

  return (
    <div
      className={`${displaySize} rounded-lg flex items-center justify-center font-bold text-sm bg-[#F0E6DC] text-gray-900 ${className}`}
    >
      {initials}
    </div>
  );
};

export default ProfilePicture;
